import api from "@/api";

const user = {
  getDetails(userId) {
    return new Promise((resolve, reject) => {
      api.get(
        `/users/${userId}/`,
        data => resolve(data),
        error => reject(error)
      );
    });
  },
  // TODO: make this api be able to accept form-data (for the sake of image upload)
  update({ userId, content }) {
    return new Promise((resolve, reject) => {
      api.patch(
        `/users/${userId}/`,
        content,
        data => resolve(data),
        error => reject(error)
      );
    });
  },
};

export default user;
